import { AxiosResponse } from 'axios'
import { useContext } from '@nuxtjs/composition-api'
import { BRAND_MEDIA_AUTHOR } from '../../../../config/bitrix-endpoints'
import {
  NewsListResponse,
} from '../../../contracts/api/QueryNews/QueryNews.Response'
import { BITRIX_API } from '../../instance'

export async function getAuthor( ctx: ReturnType<useContext> | undefined = undefined, id: number | undefined = undefined ): Promise<AxiosResponse<NewsListResponse>> {
  return await BITRIX_API(ctx).get(`${BRAND_MEDIA_AUTHOR}/${id}/detail`)
}
